<div class="exact-online-container p-8 max-w-5xl mx-auto">
  <h1 class="mb-8 text-3xl font-medium">{{ 'exact-online.title' | translate }}</h1>

  @if (loading()) {
    <div class="flex justify-center py-12">
      <mat-spinner diameter="40" />
    </div>
  } @else {
    <div class="space-y-4">
      @for (locale of locales; track locale.code) {
        @let connection = getConnection(locale.code);
        @let status = connection?.status ?? 'Disconnected';

        <mat-card class="border-l-4" [class.border-green-500]="status === 'Connected'"
                  [class.border-gray-300]="status === 'Disconnected'" [class.border-red-500]="status === 'Error'">
          <mat-card-content>
            <div class="flex items-center justify-between flex-wrap gap-4">
              <div class="flex items-center gap-4">
                <h2 class="text-xl font-medium m-0">{{ locale.label }}</h2>

                <span class="px-3 py-1 rounded-full text-sm font-medium"
                      [class.bg-green-100]="status === 'Connected'" [class.text-green-700]="status === 'Connected'"
                      [class.bg-gray-100]="status === 'Disconnected'" [class.text-gray-600]="status === 'Disconnected'"
                      [class.bg-red-100]="status === 'Error'" [class.text-red-700]="status === 'Error'">
                  {{ ('exact-online.status.' + status) | translate }}
                </span>

                @if (connection?.connectedAt && status === 'Connected') {
                  <span class="text-sm text-gray-500">
                    {{ 'exact-online.connected-since' | translate }} {{ connection?.connectedAt | date: 'medium' }}
                  </span>
                }
              </div>

              <div class="flex items-center gap-2">
                @if (isBusy(locale.code)) {
                  <mat-spinner diameter="18" />
                }
                @if (status !== 'Connected') {
                  <button mat-raised-button color="primary" type="button" (click)="connect(locale.code)" [disabled]="isAnyActionInProgress()">
                    <mat-icon>link</mat-icon>
                    {{ 'exact-online.action.connect' | translate }}
                  </button>
                } @else {
                  <button mat-stroked-button color="warn" type="button" (click)="disconnect(locale.code)" [disabled]="isAnyActionInProgress()">
                    <mat-icon>link_off</mat-icon>
                    {{ 'exact-online.action.disconnect' | translate }}
                  </button>
                }
              </div>
            </div>

            @if (status === 'Error' && connection?.lastError) {
              <div class="mt-4 p-3 bg-red-50 border-l-4 border-red-400 text-sm text-red-700">
                {{ connection?.lastError }}
              </div>
            }

            @if (status === 'Connected') {
              <div class="mt-4 flex items-end gap-4 flex-wrap">
                <mat-form-field appearance="outline" class="w-64" subscriptSizing="dynamic">
                  <mat-label>{{ 'exact-online.division-label' | translate }}</mat-label>
                  <mat-select
                    [value]="selectedDivision()[locale.code]"
                    (selectionChange)="onDivisionSelected(locale.code, $event.value)"
                    [disabled]="isLoadingDivisions(locale.code)">
                    @for (division of getDivisionOptions(locale.code); track division.code) {
                      <mat-option [value]="division.code">{{ division.description }}</mat-option>
                    }
                  </mat-select>
                  @if (isLoadingDivisions(locale.code)) {
                    <mat-hint>{{ 'exact-online.division-loading' | translate }}</mat-hint>
                  }
                </mat-form-field>

                <div class="flex items-center gap-2">
                  @if (isSavingDivision(locale.code)) {
                    <mat-spinner diameter="18" />
                  }
                  <button mat-raised-button type="button" (click)="saveDivision(locale.code)"
                          [disabled]="isAnyActionInProgress() || !selectedDivision()[locale.code]">
                    {{ 'exact-online.action.save-division' | translate }}
                  </button>
                </div>
              </div>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>
  }
</div>
